import { useMutation } from '@tanstack/react-query';
import { advisorAdminApi, CarescoutStateProbeParams } from '../api/api';

export function useCarescoutStateProbe() {
  const mutation = useMutation({
    mutationFn: (params: CarescoutStateProbeParams) =>
      advisorAdminApi.probeCarescoutState({
        quoteId: params.quoteId.trim(),
        clientId: params.clientId.trim(),
        state: params.state.trim().toUpperCase(),
      }),
  });

  return {
    probe: mutation.mutate,
    pdfBase64: mutation.data?.pdfBase64 ?? null,
    isPending: mutation.isPending,
    isError: mutation.isError,
    error: mutation.error,
    reset: mutation.reset,
  };
}
